export interface ISlickPhotoGalleryModel {
	photoUrl: string;
	title: string;
	isVideo: boolean;
}

export class SlickPhotoGalleryModel implements ISlickPhotoGalleryModel {
	photoUrl: string;
	title: string;
	isVideo: boolean;

}